module.exports = __webpack_public_path__ + "media/img/avatars/products/product-1-da57d577a8a8966698653708bccff530.jpg";